import {KeycloakUser, WorkspaceProfile} from 'types'
import {nonNullClient as client} from '../apiClient'

export const getCurrentWorkspace = async (): Promise<WorkspaceProfile> => {
	return client('user-api/user/me', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
}

export const switchWorkspace = async (data: {
	workspace: string
}): Promise<KeycloakUser> => {
	return client('user-api/user/workspace', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data,
	})
}
